import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';

function Splash() {
    const userInfo = useSelector((state) => state.user.userInfo);
    const isAuthLoading = useSelector((state) => state.user.isAuthLoading);

    return (
        <div className="splash-page">
            <Navigation />

            <div className="splash-content">
                <div className="hero-section">
                    <h1 className="brand-title">Raising Girls</h1>
                    <h2 className="event-subtitle">2026 Annual Luncheon</h2>

                    <div className="mission-statement">
                        <p>
                            Welcome to the Table Captain Portal. Manage your guests,
                            track RSVPs, and help us empower the next generation of strong women.
                        </p>
                    </div>

                    <div className="user-status-section">
                        {isAuthLoading ? (
                            <div className="loading-bar" />
                        ) : userInfo ? (
                            <div className="welcome-back-card">
                                <p className="welcome-text">Welcome back, <span className="highlight-name">{userInfo.userDetails}</span>!</p>
                                <p className="action-hint">Click on the "My Guests" tab to manage your table.</p>
                            </div>
                        ) : (
                            <div className="login-prompt" style={{ border: 'none', padding: 0 }}>
                                <Link to="/login" className="submit-button" style={{
                                    display: 'inline-block',
                                    width: 'auto',
                                    padding: '1rem 3rem',
                                    fontSize: '1.2rem',
                                    marginTop: '1rem'
                                }}>
                                    Login to Portal
                                </Link>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            <footer className="splash-footer">
                <p>&copy; 2026 Raising Girls. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Splash;
